import { LoaderTypeEnum } from 'libs/shared/utils/loader/src/lib/+state/loader.models'

export interface MenuItemsEntity {
  uuid: string
  auction: string
  button_type: string
  label: string
  order: number
  is_visible: boolean
  category: string | null | undefined
  item: string | null
  infobooth: string | null
  url: string | null
  item_type: string | null
  external_link: boolean | null
  hub: string | null
  widget_page: string | null
  icon: string | null
}

export enum MenuItemsButtonTypesEnum {
  Ticketing = 'event_ticketing',
  Infobooth = 'infobooth',
  ExternalLink = 'external_link',
  ActivityFeed = 'activity_feed',
  WidgetPage = 'widget_page',
  TotalRaised = 'total_raised',
  SearchAndCategories = 'search_and_categories',
  Item = 'item',
  ItemType = 'item_type',
  ContactHost = 'contact_organizer',
  FavouriteItems = 'favourite_items',
  AllItems = 'all_items',
  MyAccount = 'my_account',
  Category = 'category',
  Hub = 'hub',
  DonateItem = 'donate_item',
}

export enum MenuItemPageFrontendRouteEnum {
  INFO = 'info',
  ACCOUNT = 'account',
  CATEGORIES = 'categories',
  ITEMS = 'items',
  FAVOURITES = 'favourites',
  EVENT_TICKETS = 'event-tickets',
  WIDGETS = 'widgets',
  DONATE_ITEM = 'donate-item',
}

export const MENU_ITEMS_LOADER = {
  reorderMenuItems: {
    id: 'reorderMenuItems',
    type: LoaderTypeEnum.Dialog,
    message: 'LOADER.REORDERING_MENU_ITEMS',
  },
  deleteMenuItem: {
    id: 'deleteMenuItem',
    type: LoaderTypeEnum.Dialog,
    message: 'LOADER.DELETING_MENU_ITEM',
  },
  loadResources: {
    id: 'loadMenuItemResources',
    type: LoaderTypeEnum.Dialog,
    message: 'LOADER.LOADING_MENU_RESOURCES',
  },
}
